var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams, stringifyQueryParams } from "../utils";
import { UIModelClientsList, UIModelSingleClient } from "./clients.model";
import { unpackClientsList, unpackSingleClient, packClient, packFbCallback, packCreatePartnerChangeInfo, unpackPartnerChangePreview, packVATPayload, unpackPaymentToken, packChangeChatSupportPayload, unpackPaymentSessionData, } from "./clients.mapper";
import removeNullValues from "@/utilities/removeNullValues";
import { unpackPartnerChangeRequest, unpackPartnerChangeInfo, unpackPaymentCheck, } from "../partners/partners.mapper";
import { UIModelPartnerChangeRequestsInfo } from "../partners/partners.model";
var clientsUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/clients");
};
var clientUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId);
};
var paymentTokenURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/payment");
};
var clientDataCsvURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/clients/info/export");
};
var clientFbCallbackURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/control/fb_login_callback");
};
var generateClientDataToEmailUrl = function (partnerId) {
    return "/partners/".concat(partnerId, "/clients/info/export_to_email?");
};
var partnerChangeRequestURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests");
};
var partnerChangeRequestPreviewURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, targetPartnerId = _a.targetPartnerId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests/preview/").concat(targetPartnerId);
};
var cancelPartnerChangeURL = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests/").concat(partnerChangeRequestId, "/cancel");
};
var vatInfoUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/set_vat_info");
};
var checkPaymentUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/control/payment_check");
};
var aditionalPaymentDetailsUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/payment/details");
};
var changeChatSupportUrl = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/control/enabled_for_chat_support");
};
var paymentSessionURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/add_payment_method");
};
var getClientPaymentMethodsUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/payment_methods");
};
var clientBillingDataUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/billing_data");
};
export var getClientsList = function (_a, queryParams) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(clientsUrl({ partnerId: partnerId }), {
                        params: queryParams && packQueryParams(queryParams),
                        paramsSerializer: stringifyQueryParams,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelClientsList(unpackClientsList(data))];
            }
        });
    });
};
export var getClient = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(clientUrl({ partnerId: partnerId, clientId: clientId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelSingleClient(unpackSingleClient(data))];
            }
        });
    });
};
export var createClient = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(clientsUrl({ partnerId: partnerId }), packClient(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelSingleClient(unpackSingleClient(data))];
            }
        });
    });
};
export var updateClient = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var body, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    body = removeNullValues(packClient(payload));
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(clientUrl({ partnerId: partnerId, clientId: clientId }), body)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackSingleClient(data)];
            }
        });
    });
};
export var getClientPaymentToken = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(paymentTokenURL({ partnerId: partnerId, clientId: clientId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentToken(data)];
            }
        });
    });
};
export var getClientData = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(clientDataCsvURL({ partnerId: partnerId }), {
                        headers: {
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var postFbCallbackToken = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(clientFbCallbackURL({ partnerId: partnerId, clientId: clientId }), packFbCallback(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var generateClientDataToEmail = function (partnerId, queryParams) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(generateClientDataToEmailUrl(partnerId), {}, {
                    params: queryParams && packQueryParams(queryParams),
                    paramsSerializer: stringifyQueryParams,
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var createPartnerChangeRequest = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, payload = _a.payload;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChangeRequestURL({ partnerId: partnerId, clientId: clientId }), packCreatePartnerChangeInfo(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangeRequest(data)];
            }
        });
    });
};
export var getPartnerChangeRequests = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChangeRequestURL({ partnerId: partnerId, clientId: clientId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerChangeRequestsInfo(unpackPartnerChangeInfo(data))];
            }
        });
    });
};
export var getPartnerChangeRequestPreview = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, targetPartnerId = _a.targetPartnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChangeRequestPreviewURL({ partnerId: partnerId, clientId: clientId, targetPartnerId: targetPartnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangePreview(data)];
            }
        });
    });
};
export var cancelPartnerChangeRequest = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId, payload = _a.payload;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(cancelPartnerChangeURL({ clientId: clientId, partnerId: partnerId, partnerChangeRequestId: partnerChangeRequestId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangeRequest(data)];
            }
        });
    });
};
export var updateBusinessVAT = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(vatInfoUrl({ partnerId: partnerId, clientId: clientId }), packVATPayload(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var checkPayment = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(checkPaymentUrl({ partnerId: partnerId, clientId: clientId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentCheck(data)];
            }
        });
    });
};
export var submitAdditionalDetails = function (_a) {
    var payload = _a.payload, partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(aditionalPaymentDetailsUrl({ partnerId: partnerId, clientId: clientId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentCheck(data)];
            }
        });
    });
};
export var updateChatSupport = function (_a, payload) {
    var clientId = _a.clientId, partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(changeChatSupportUrl({ clientId: clientId, partnerId: partnerId }), removeNullValues(packChangeChatSupportPayload(payload)))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackSingleClient(data)];
            }
        });
    });
};
export var getClientPaymentSession = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(paymentSessionURL({ partnerId: partnerId, clientId: clientId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentSessionData(data)];
            }
        });
    });
};
export var getClientPaymentMethods = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getClientPaymentMethodsUrl({ clientId: clientId, partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.data];
            }
        });
    });
};
export var getClientBillingData = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(clientBillingDataUrl({ clientId: clientId, partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, {
                            partnerSubscriptionStatus: data === null || data === void 0 ? void 0 : data.partnerSubscriptionStatus,
                        }];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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